<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="justify-end align-end text-end">
        <v-btn color="success" @click="showModal">
          <v-icon class="white--text">mdi-plus</v-icon>
          Create USSD Poll
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-dialog v-model="dialog" width="600">
        <ussd-campaign-form @campaignSuccess="campaigns"/>
      </v-dialog>
    </v-row>
    <v-row>
      <v-col cols="12">
        <table-widget title="USSD poll" :headers="headers" :table-row-data="sms" @deleteItem="deleteItem"
                      @freezeUnfreeze="confirmMessageAndSend"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TableWidget from "@/components/widgets/tables/TableWidget";
import SmsCampaignForm from "@/components/widgets/forms/smsCampaignForm";
import {deleteRequest, getRequest, postRequest} from "@/api/apirepository";
import CallCampaignForm from "@/components/widgets/forms/callCampaignForm";
import UssdCampaignForm from "@/components/widgets/forms/ussdCampaignForm";

export default {
  metaInfo: {
    title: 'USSD Center',
  },
  name: "USSDPollCenter",
  components: {UssdCampaignForm, CallCampaignForm, SmsCampaignForm, TableWidget},
  data() {
    return {
      headers: [
        {
          text: 'Electoral Region',
          align: 'left',
          sortable: true,
          value: 'county',
        },
        {text: 'Level', value: 'level'},
        {text: 'Status', value: 'status'},
        {text: 'Questions', value: 'qCount'},
        {text: 'Responses', value: 'rCount'},
        {text: 'Cost', value: 'cost'},
        {text: 'Actions', value: 'action'}
      ],
      sms: [],
      dialog: false,
    }
  },
  methods: {
    showModal() {
      this.dialog = true;
    },
    campaigns() {
      this.dialog = false;
      this.getSMSCampaigns()
    },
    confirmMessageAndSend(e) {
      postRequest('releasePoll', {
        id: e.item.id
      }).then(res => {
        swal.fire('Success', '', 'success')
      }).catch(e => {
        console.log(e)
      })
    },
    getSMSCampaigns() {
      getRequest('ussdPoll', {
        params: {
          id: this.$store.state.user.id
        }
      }).then(({data}) => {
        this.sms = data;
      }).catch(e => {
        console.log(e)
      })
    },
    deleteItem(e) {
      swal.fire({
        title: 'Delete Campaign?',
        text: "This step is irrevesible",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Delete!'
      }).then((result) => {
        if (result.value) {
          deleteRequest('ussdPoll', e.item.id).then(e => {
            this.getSMSCampaigns()
            swal.fire('Deleted Successfully', '', "success")
          }).catch(e => {
            console.log(e)
          })
        }
      })

    },
  },
  created() {
    this.getSMSCampaigns()
  }
}
</script>

<style scoped>

</style>